"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  label: 'None',
  value: null
}, {
  label: 'Sum',
  value: 'sum'
}, {
  label: 'Average',
  value: 'avg'
}, {
  label: 'Maximum',
  value: 'max'
}, {
  label: 'Minimum',
  value: 'min'
}, {
  label: 'Count',
  value: 'count'
}];
exports["default"] = _default;